import { FC } from 'react'
import { TabNavBarItem } from '@/componentsV2/atoms/TabNavBarItem'
import styles from './index.module.scss'

type Props = {
  items: {
    label: string
    href: string
    isActive?: boolean
    isNew?: boolean
    isBeta?: boolean
    isExternal?: boolean
  }[]
}

export const TabNavBar: FC<Props> = ({ items }) => {
  return (
    <div className='container'>
      <div className={styles.container}>
        <div className={styles.inner}>
          <div className={styles.items}>
            {items.map((item) => (
              <TabNavBarItem
                key={item.href}
                label={item.label}
                href={item.href}
                isActive={item.isActive}
                isNew={item.isNew}
                isBeta={item?.isBeta}
                isExternal={item?.isExternal}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
